module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/catNhw/tc-custom/9781635763805.jpg?1736859391747",
      "alt": "This image is the cover for the book All In"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("All In\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A lovelorn, Portland P.I. must prove a man’s innocence when no one else will in this murder mystery from the author of "), _c('i', [_vm._v("Betting Blind")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" Lennox Cooper, flinty ex-cop and poker playing private detective, stands alone in championing Tomek Jagoda, darling son of a local crime family, accused of murdering his high-living girlfriend. The cops have proof that will send Tomek to prison for life."), _c('br'), _c('br'), _vm._v(" Meanwhile, prosecuting the case is a Viking goddess of a woman, as smart as she is stunning, who draws everyone's adoration. Next to her, Lennox feels like a garden gnome. It doesn’t help that August Kline, Lennox’s boss and Tomek’s defense attorney, is ready to throw his client under the bus in a plea deal that carries a ten-year sentence just to date the prosecutor."), _c('br'), _c('br'), _vm._v(" As Lennox untangles all the lies surrounding the case, she sees deeper into Tomek’s humanity and into her own. She realizes that she’s in love with Kline, who’s in lust with the prosecutor. Now, if Lennox hopes to truly save an innocent man, she must wager her job, her love, and her own safety to find the killer…")]), _c('b', [_vm._v("“Readers will look forward to seeing more of the feisty and resourceful Lennox.”—"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lily Gardner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0